import {
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  SnEnabledPartnerSiteDto,
  TrackedSerialNumberListingDto,
  TrackedSerialNumberGetDto,
  UpdateTrackedSerialNumberRequest,
  SyncSerialNumbersFromEpicorRequest,
  SyncSerialNumbersResult,
  AssignSerialNumberToRigRequest,
  TrackedSerialNumberAuditDisplayDto,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  OptionItemDto,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class TrackedSerialNumbersService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static getSnEnabledSites(
    params: {
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<SnEnabledPartnerSiteDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/sites';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getListing(
    params: {
      /**  */
      partnerSiteId: number;
      /**  */
      rigId?: number;
      /**  */
      productionDateFrom?: Date;
      /**  */
      productionDateTo?: Date;
      /**  */
      serviceStatusFilter?: string;
      /**  */
      certificationStatus?: string;
      /**  */
      lastServiceDateFrom?: Date;
      /**  */
      lastServiceDateTo?: Date;
      /**  */
      lastServiceType?: string;
      /**  */
      nextCosFrom?: Date;
      /**  */
      nextCosTo?: Date;
      /**  */
      nextUecocFrom?: Date;
      /**  */
      nextUecocTo?: Date;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<TrackedSerialNumberListingDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/sites/{partnerSiteId}/listing';
      url = url.replace('{partnerSiteId}', params['partnerSiteId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        RigId: params['rigId'],
        ProductionDateFrom: params['productionDateFrom'],
        ProductionDateTo: params['productionDateTo'],
        ServiceStatusFilter: params['serviceStatusFilter'],
        CertificationStatus: params['certificationStatus'],
        LastServiceDateFrom: params['lastServiceDateFrom'],
        LastServiceDateTo: params['lastServiceDateTo'],
        LastServiceType: params['lastServiceType'],
        NextCosFrom: params['nextCosFrom'],
        NextCosTo: params['nextCosTo'],
        NextUecocFrom: params['nextUecocFrom'],
        NextUecocTo: params['nextUecocTo'],
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
      /**  */
      partnerSiteId?: number;
      /**  */
      rigId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<TrackedSerialNumberGetDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted'],
        partnerSiteId: params['partnerSiteId'],
        rigId: params['rigId']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TrackedSerialNumberGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateTrackedSerialNumberRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TrackedSerialNumberGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sync(
    params: {
      /** requestBody */
      body?: SyncSerialNumbersFromEpicorRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<SyncSerialNumbersResult>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static assignToRig(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: AssignSerialNumberToRigRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<TrackedSerialNumberGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/{id}/assign';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAuditHistory(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<TrackedSerialNumberAuditDisplayDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/{id}/audit-history';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportToCsv(
    params: {
      /**  */
      partnerSiteId: number;
      /**  */
      rigId?: number;
      /**  */
      serviceStatusFilter?: string;
      /**  */
      searchText?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<string>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/tracked-serial-numbers/sites/{partnerSiteId}/csv';
      url = url.replace('{partnerSiteId}', params['partnerSiteId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        rigId: params['rigId'],
        serviceStatusFilter: params['serviceStatusFilter'],
        searchText: params['searchText']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
